import { ObjectClass } from '../enums';

import { IObjectClass } from './../interfaces/object-class';

export const AuditObjectClasses: IObjectClass[] = [
  {
    name: 'Environment',
    value: ObjectClass.Environment,
    icon: 'person',
    pluralName: 'Environments',
  },
  {
    name: 'Disease',
    value: ObjectClass.Disease,
    icon: 'person',
    pluralName: 'Diseases',
  },
  {
    name: 'Foundation',
    value: ObjectClass.Foundation,
    icon: 'person',
    pluralName: 'Foundations',
  },
  {
    name: 'Fund',
    value: ObjectClass.Fund,
    icon: 'person',
    pluralName: 'Funds',
  },
  {
    name: 'Region',
    value: ObjectClass.Region,
    icon: 'person',
    pluralName: 'Regions',
  },
];

